import React, { useState } from 'react';
import { Star } from 'lucide-react';
import ClientInput from '../../components/ClientInput';
import { useSales } from '../../../../contexts/SalesContext';

const ClientSection = ({ client, saleId }) => {
  const { updateSale } = useSales();
  const [isChanging, setIsChanging] = useState(false);

  const handleClientChange = async (newClient) => {
    try {
      await updateSale(saleId, {
        client: newClient,
        history: [{
          type: newClient ? 'client_added' : 'client_removed',
          timestamp: new Date().toISOString(),
          data: { clientName: newClient?.name }
        }]
      });
      setIsChanging(false);
    } catch (err) {
      console.error('Error al actualizar el cliente:', err);
    }
  };

  if (!client || isChanging) {
    return (
      <div className="bg-white dark:bg-gray-800 rounded-lg p-4 border dark:border-gray-700">
        <div className="flex items-center justify-between mb-2">
          <h2 className="font-medium text-gray-900 dark:text-white">Cliente</h2>
          <span className="text-sm text-gray-500 dark:text-gray-400">
            {isChanging ? 'Cambiar cliente' : 'Sin cliente asignado'}
          </span>
        </div>
        <ClientInput 
          onClientChange={handleClientChange} 
          onCancel={isChanging ? () => setIsChanging(false) : undefined}
        />
      </div>
    );
  }

  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg p-4 border dark:border-gray-700">
      <div className="flex flex-col">
        <div className="flex items-center justify-between">
          <h2 className="font-medium text-gray-900 dark:text-white">Cliente</h2>
          {client.hasCurrentAccount && (
            <Star className="w-4 h-4 text-yellow-500 dark:text-yellow-400" />
          )}
        </div>
        <div className="mt-1 flex items-center justify-between">
          <div className="flex flex-col">
            <span className="text-lg font-medium text-gray-900 dark:text-white">
              {client.name}
            </span>
            {client.hasCurrentAccount && (
              <span className={`text-sm ${
                client.balance >= 0 ? 'text-green-600 dark:text-green-400' : 'text-red-600 dark:text-red-400'
              }`}>
                Saldo: ${client.balance?.toLocaleString() ?? 0}
              </span>
            )}
          </div>
          <div className="flex gap-4">
            <button
              onClick={() => handleClientChange(null)}
              className="text-sm text-red-600 hover:text-red-700 dark:text-red-400 dark:hover:text-red-300"
            >
              Quitar cliente
            </button>
            <button
              onClick={() => setIsChanging(true)}
              className="text-sm text-blue-600 hover:text-blue-700 dark:text-blue-400 dark:hover:text-blue-300"
            >
              Cambiar cliente
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientSection; 